export default import.meta.ROLLDOWN_FILE_URL_OWkkS$J_bktHla5g5Zqn4A